import { get } from 'lodash'

// isLogged
export const isLogged = ({ user }) => {
  return get(user, 'id', null) !== null
} // isLogged

export const user = ({ user }) => user
export const userIsEmployee = ({ user }) => user.last_tenant_id !== user.id
export const userIsCompany = ({ user }) => user.type === 'company'
export const userIsPatient = ({ user }) => user.type === 'patient'
export const userIsTenant = ({ user }) => user.type === 'tenant'
export const userIsProfessional = ({ user }) => user.type === 'professional'
export const userIsProfessionalOrCompany = ({ user }) => user.type === 'professional' || user.type === 'company'



// WEBPACK FOOTER //
// ./src/store/getters/user.js